export default __webpack_public_path__ + "static/media/road-A-photo.6c3d96e4.svg";